module.exports = __webpack_public_path__ + "img/Toyota.5a992929.png";